// extracted by mini-css-extract-plugin
export var filterIncDec = "_al-0";
export var leftBorder = "_al-1";
export var rightBorder = "_al-2";
export var stringInput = "_al-3";